(() => {
  if (window.__evoNavigationWarmupLoaded) {
    return;
  }

  window.__evoNavigationWarmupLoaded = true;

  const prefetchSummaryUrl = (summaryElement, fetchPriority = "high") => {
    if (!summaryElement?.matches?.("summary[data-url]")) {
      return;
    }

    const targetUrl = summaryElement.getAttribute("data-url");
    if (!targetUrl || targetUrl === "#") {
      return;
    }

    let url;
    try {
      url = new URL(targetUrl, window.location.href);
    } catch {
      return;
    }

    if (url.origin !== window.location.origin) {
      return;
    }

    window.__evoPrefetchedSummaryUrls = window.__evoPrefetchedSummaryUrls || new Set();
    if (window.__evoPrefetchedSummaryUrls.has(url.href)) {
      return;
    }

    const linkElement = document.createElement("link");
    linkElement.rel = "prefetch";
    linkElement.as = "document";
    linkElement.href = url.href;
    linkElement.fetchPriority = fetchPriority;
    document.head.appendChild(linkElement);
    window.__evoPrefetchedSummaryUrls.add(url.href);
  };

  const summaryFromEvent = (event) => event.target?.closest?.("summary[data-url]");

  document.addEventListener("pointerenter", (event) => prefetchSummaryUrl(summaryFromEvent(event)), {
    capture: true,
    passive: true
  });
  document.addEventListener("focusin", (event) => prefetchSummaryUrl(summaryFromEvent(event)), true);
  document.addEventListener("touchstart", (event) => prefetchSummaryUrl(summaryFromEvent(event)), {
    capture: true,
    passive: true
  });

  if (window.__evoSummaryUrlWarmupScheduled) {
    return;
  }

  window.__evoSummaryUrlWarmupScheduled = true;

  const requestIdle = window.requestIdleCallback || ((callback) => setTimeout(callback, 1500));
  const schedule = () => {
    requestIdle(() => {
      const urls = Array.from(document.querySelectorAll("summary[data-url]"))
        .map((summaryElement) => summaryElement.getAttribute("data-url"))
        .filter(Boolean);

      [...new Set(urls)].slice(0, 12).forEach((targetUrl, index) => {
        setTimeout(() => {
          const summaryElement = document.createElement("summary");
          summaryElement.setAttribute("data-url", targetUrl);
          prefetchSummaryUrl(summaryElement, "low");
        }, index * 250);
      });
    }, { timeout: 4000 });
  };

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }
})();
